import { table2dataType } from '@common/table-configs/types/decorator';
import { tableToData } from '@common/decorators/table';
import { cell2data } from '@components/data-display/table/utils/decorators/cell-to-data';

export const table2data: table2dataType = (record, dataIndex, value) => {
  return tableToData(record, dataIndex, value, cell2data);
};
